<template>
    <div class="p-8">
        <div class="flex flex-col gap-4">
            <h1 class="text-2xl font-bold mb-6">Select KPIs by Code</h1>
            <label class="font-semibold">Select Date Range:</label>
            <span class="text-sm text-gray-500">All times in US Eastern Time Zone</span>
            <div class="flex gap-4">
                <input type="date" v-model="startDate" class="input input-bordered w-full max-w-xs"
                    placeholder="Start Date" />
                <input type="date" v-model="endDate" class="input input-bordered w-full max-w-xs"
                    placeholder="End Date" />
            </div>

            <label class="font-semibold mt-4">Promo Code:</label>
            <div class="dropdown">
                <div tabindex="0" role="button" class="btn m-1" @click="toggleDropdown">
                    {{ selectedPromoCode || 'Select Promo Code' }}
                </div>
                <ul v-show="isDropdownOpen" tabindex="0"
                    class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
                    <li v-if="promoCodesLoading" class="text-center text-gray-500">Loading promo codes...</li>
                    <li v-else-if="promoCodes.length === 0" class="text-center text-gray-500">No promo codes available
                    </li>
                    <li v-for="code in promoCodes" :key="code">
                        <a @click="selectPromoCode(code)">{{ code }}</a>
                    </li>
                </ul>
            </div>

            <button class="btn btn-primary w-full max-w-xs mt-4" :disabled="!isButtonActive"
                @click="fetchData(selectedPromoCode, startDate, endDate)">
                Generate Report
            </button>
        </div>

        <hr class="my-8 border-t-2 border-gray-200" />

        <div v-if="loading" class="flex flex-col items-center mt-8">
            <span class="loading loading-spinner loading-lg"></span>
            <p class="text-xl font-semibold mt-4">Data is being retrieved...</p>
        </div>

        <div v-if="!loading && dataLoaded" class="grid grid-cols-2 gap-24 mt-8">
            <div class="card bg-base-200 shadow-lg p-12">
                <h2 class="text-4xl font-semibold">Registrations</h2>
                <p class="text-3xl font-bold mt-6">{{ formatNumber(reportData.registrations) }}</p>
            </div>
            <div class="card bg-base-200 shadow-lg p-12">
                <h2 class="text-4xl font-semibold">FTPs</h2>
                <p class="text-3xl font-bold mt-6">{{ formatNumber(reportData.ftps) }}</p>
            </div>
            <div class="card bg-base-200 shadow-lg p-12">
                <h2 class="text-4xl font-semibold">GGR (SC)</h2>
                <p class="text-3xl font-bold mt-6">{{ formatNumber(reportData.ggr) }}</p>
            </div>
            <div class="card bg-base-200 shadow-lg p-12">
                <h2 class="text-4xl font-semibold">Purchases ($)</h2>
                <p class="text-3xl font-bold mt-6">{{ formatCurrency(reportData.purchases) }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'KeyPerformanceView',
    data() {
        return {
            startDate: '',
            endDate: '',
            loading: false,
            dataLoaded: false,
            promoCodesLoading: true,
            promoCodes: [],
            selectedPromoCode: '',
            isDropdownOpen: false,
            reportData: {
                registrations: 0,
                ftps: 0,
                ggr: 0,
                purchases: 0,
            },
        };
    },
    computed: {
        isButtonActive() {
            if (!this.startDate || !this.endDate || !this.selectedPromoCode) return false;
            const start = new Date(this.startDate);
            const end = new Date(this.endDate);
            const now = new Date();
            return start <= end && start <= now;
        }
    },
    methods: {
        formatNumber(value) {
            if (value == null) return '0';
            return value.toLocaleString();
        },
        formatCurrency(value) {
            if (value == null) return '$0';
            return `$${value.toLocaleString()}`;
        },
        fetchPromoCodes() {
            this.promoCodesLoading = true;

            const token = this.$store.getters['access_token'];
            const url = `${process.env.VUE_APP_API_GATEWAY_URL}/promo/codes`;

            axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then(response => {
                this.promoCodes = response.data;
                this.promoCodesLoading = false;
            }).catch(error => {
                console.error('Error fetching promo codes:', error);
                this.promoCodesLoading = false;
            });
        },
        async fetchData(code, start, end) {
            this.loading = true;
            this.dataLoaded = false;

            const token = this.$store.getters['access_token'];
            const url = `${process.env.VUE_APP_API_GATEWAY_URL}/stats/kpi/${code}`;

            console.log(url, start, end);
            try {
                const response = await axios.get(url, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: { start, end },
                });

                this.reportData = response.data;
            } catch (error) {
                if (error.code === 'ECONNABORTED') {
                    console.error('Request timed out:', error.message);
                } else {
                    console.error('Error details:', {
                        message: error.message,
                        code: error.code,
                        response: error.response?.data,
                        config: error.config,
                    });
                }
            } finally {
                this.loading = false;
                this.dataLoaded = true;
            }
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        selectPromoCode(code) {
            this.selectedPromoCode = code;
            this.isDropdownOpen = false;
        }
    },
    mounted() {
        this.fetchPromoCodes();
    },
};
</script>

<style scoped>
.card {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}
</style>
